import SEO from '@/components/base/SEO';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Hero from './components/Hero';
import CategoryGrid from './components/CategoryGrid';
import HotItems from './components/HotItems';
import LatestUpdates from './components/LatestUpdates';
import FAQ from './components/FAQ';
import { siteInfo } from '@/mocks/home';

export default function Home() {
  const schemaData = {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'Organization',
        name: siteInfo.name,
        url: siteInfo.url,
        description: siteInfo.description,
        contactPoint: {
          '@type': 'ContactPoint',
          email: 'service@fanhao.example.com',
          contactType: 'customer service',
          availableLanguage: ['Chinese'],
        },
      },
      {
        '@type': 'WebSite',
        name: siteInfo.name,
        url: siteInfo.url,
        description: siteInfo.description,
        inLanguage: 'zh-Hans',
      },
      {
        '@type': 'WebPage',
        name: `${siteInfo.name} - 首页`,
        url: siteInfo.url,
        description: siteInfo.description,
        inLanguage: 'zh-Hans',
        isPartOf: { '@id': `${siteInfo.url}#website` },
        about: { '@id': `${siteInfo.url}#organization` },
      },
      {
        '@type': 'FAQPage',
        mainEntity: [
          {
            '@type': 'Question',
            name: '番号大全是什么？',
            acceptedAnswer: {
              '@type': 'Answer',
              text: '番号大全是专注于番号信息收录与分类检索的专业平台，提供按类型、演员、厂牌、系列等多维度的番号查询服务。',
            },
          },
          {
            '@type': 'Question',
            name: '如何按演员搜索番号？',
            acceptedAnswer: {
              '@type': 'Answer',
              text: '在首页点击「按演员」分类入口，进入演员番号列表页面。也可以通过顶部搜索框直接输入演员名称进行检索。',
            },
          },
          {
            '@type': 'Question',
            name: '番号大全是否收费？',
            acceptedAnswer: {
              '@type': 'Answer',
              text: '番号大全完全免费使用。所有番号查询、分类浏览、信息检索功能均不收取任何费用。',
            },
          },
        ],
      },
    ],
  };

  return (
    <>
      <SEO
        title={`${siteInfo.name} - ${siteInfo.tagline}`}
        description={siteInfo.description}
        keywords="番号大全,番号查询,番号索引,番号分类,番号搜索,女优番号,厂牌番号列表"
        canonicalUrl={siteInfo.url}
        ogTitle={`${siteInfo.name} - ${siteInfo.tagline}`}
        ogDescription={siteInfo.description}
        ogType="website"
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(schemaData) }}
      />

      <Navbar />

      <main>
        <Hero />
        <CategoryGrid />
        <HotItems />
        <LatestUpdates />
        <FAQ />
      </main>

      <Footer />
    </>
  );
}